import { useTranslation } from 'react-i18next';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { ModalView } from '@/data/hook/question/useModalView';
import Activity from '@/models/Activity';
import QuestionCounter from './QuestionCounter';
import QuestionFormFactory from './QuestionFormFactory';
import QuestionSidebar from './QuestionSidebar';
import { Question } from '@/models/Question';

type EditorViewProps = {
  questions: Question[];
  activeIndex: number;
  view: ModalView;
  activity: Activity;
  onSelectActive: (index: number) => void;
  onAddQuestion: () => void;
  onDeleteQuestion: (index: number) => void;
};

export default function EditorView({
  questions,
  activeIndex,
  view,
  activity,
  onSelectActive,
  onAddQuestion,
  onDeleteQuestion,
}: EditorViewProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal',
  });

  return (
    <div className="flex flex-col gap-4">
      <QuestionCounter
        counter={questions.length}
        activeIndex={activeIndex}
        view={view}
      />

      <div className="flex gap-8">
        <QuestionSidebar
          questions={questions}
          activeIndex={activeIndex}
          view={view}
          onSelect={onSelectActive}
          onAdd={onAddQuestion}
          onDelete={onDeleteQuestion}
        />
        <div className="flex-1">
          <ConditionalRenderer condition={!questions.length || activeIndex < 0}>
            <span className="text-base-content text-sm">
              {t('selectQuestionPlaceholder')}
            </span>
          </ConditionalRenderer>

          {questions.map((question, index) => (
            <div
              key={question.identifier}
              className={index !== activeIndex ? 'hidden' : undefined}
            >
              <QuestionFormFactory
                activity={activity}
                question={question}
                isActive={index === activeIndex}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
